<template>
  <div class="Feature"
    :is="tagType"
    v-bind="featureAttributes">

    <thumbnail
      :image="getImage(image)"
      :tags="resolvedTags" />

  </div>
</template>

<script>
export default {
  name: 'Feature',
  props: {
    image: {
      type: Object
    },
    route: {
      type: [Object, String]
    },
    link: {
      type: String
    },
    tags: {
      type: Array
    }
  },

  computed: {
    /**
     * Return appropriate top-level tag
     * @return {String}
     */
    tagType () {
      // Handle standard link
      if (this.link) return 'a'

      // Handle internal route
      if (this.route) return 'router-link'

      return 'div'
    },

    /**
     * Return appropriate attributes depending on top-level tag
     * @return {Object}
     */
    featureAttributes () {
      // Handle standard link
      if (this.link) return { href: this.link }

      // Handle internal route
      if (this.route) return { to: this.route }
    },

    /**
     * Resolved list of tags
     * @return {Array}
     */
    resolvedTags () {
      const tags = []

      this.tags.forEach((tag, index) => {
        tags.push(tag)
        tags[index].large = true
      })

      return tags
    }
  },

  methods: {
    /**
     * Add default options to image
     * @param  {Object} image
     * @return {Object}
     */
    getImage (image) {
      // image.zoom = image.zoom || true
      return image
    }
  }
}
</script>



// WEBPACK FOOTER //
// Feature.vue?668bd584